// extracted by mini-css-extract-plugin
export default {"btn":"ButtonX_btn__iJzUd"};